module.exports = __webpack_public_path__ + "img/banner4.67b102c2.jpg";